import { CallHistoryMethodAction, push } from 'connected-react-router';
import { ApplicationState, NEiTThunk, routes } from '..';
import { Matricola, TipoIntervento } from '../core-assistenza/models';
import notification from '../notification';
import { OrdiniActions } from './actionTypes';
import * as ordiniApi from './api';
import { OrdineRiga, OrdineNuovo, StatoOrdine } from './models';

type Actions = 
    OrdiniActions           |
    CallHistoryMethodAction

export const svuotaCarrello = () => ({ type: 'ordini/SVUOTA_CARRELLO' });

export const addConsumabiliToCart = (
    matricola: Matricola,
    dettagli: OrdineRiga[]
) => ({ type: 'ordini/ADD_CONSUMABILI_TO_CART', matricola, dettagli });

export const rimuoviConsumabile = (
    idSpecifica: string, 
    consumabile: OrdineRiga
) => ({ type: 'ordini/RIMUOVI_CONSUMABILE_FROM_CART', idSpecifica, consumabile });

export const loadMatricole = (
    search?: string
): NEiTThunk<void, Actions> => (dispatch, getState) => {
    dispatch({ type: 'core/BEGIN_AJAX_CALL' });

    search = search || '';
    const state: ApplicationState = getState();
    const refreshCache: boolean = state.ordini.destinatariMatricole.refreshCache;

    ordiniApi.getDestinatariMatricole(state, TipoIntervento.Hardware, search, refreshCache)
        .then(result => {
            dispatch({ type: 'ordini/LOAD_DESTINATARI_MATRICOLE', value: result });
            dispatch({ type: 'core/END_AJAX_CALL' });
        })
        .catch(error => {
            dispatch({ type: 'core/END_AJAX_CALL' });
            notification.error(error.message);
        })
}

export const loadConsumabili = (
    idSpecifica: string
): NEiTThunk<void, Actions> => (dispatch, getState) => {
    dispatch({ type: 'core/BEGIN_AJAX_CALL' });

    const state: ApplicationState = getState();
    const refreshCache: boolean = state.ordini.consumabili.refreshCache;
    ordiniApi.getConsumabiliMatricola(state, idSpecifica, refreshCache)
        .then(result => {
            dispatch({ type: 'ordini/LOAD_CONSUMABILI_MATRICOLA', value: result });
            dispatch({ type: 'core/END_AJAX_CALL' });
        })
        .catch(error => {
            dispatch({ type: 'core/END_AJAX_CALL' });
            notification.error(error.message);
        })
}

export const loadOrdini = (
    search: string, 
    page: number,
    stato?: StatoOrdine
): NEiTThunk<void, Actions> => (dispatch, getState) => {
    dispatch({ type: 'core/BEGIN_AJAX_CALL' });
    
    const state: ApplicationState = getState();
    const refreshCache: boolean = state.chiamate.chiamate.refreshCache;

    ordiniApi.getOrdini(state, search, page, refreshCache, stato)
        .then(ordini => {
            dispatch({ type: 'ordini/LOAD_ORDINI', value: ordini, page: page });

            dispatch({ type: 'core/END_AJAX_CALL' });
        })
        .catch(error => {
            dispatch({ type: 'core/END_AJAX_CALL' });
            notification.error(error.message);
        });
}

export const saveOrdine = (
    ordine: OrdineNuovo
): NEiTThunk<void, Actions> => (dispatch, getState) => {
    dispatch({ type: 'core/BEGIN_AJAX_CALL' });
        
    const state = getState();

    ordiniApi.saveOrdine(state, ordine)
        .then(idOrdine => {
            ordine.idOrdine = idOrdine;

            dispatch({ type: 'ordini/SAVE_ORDINE', value: ordine });
            dispatch({ type: 'core/END_AJAX_CALL' });

            notification.success('Segnalazione inviata con successo.', 'Invio completato');

            dispatch({ type: 'ordini/SVUOTA_CARRELLO' });

            dispatch(push(routes.core.main + routes.ordini.elenco));
        })
        .catch((error) => {
            dispatch({ type: 'core/END_AJAX_CALL' });
            notification.error(error.message);
        });
}